"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExpired = void 0;
var cache_promise_1 = require("../cache-promise");
function isExpired(opts, entry) {
    var age = cache_promise_1.getTime() - entry.time;
    return age > opts.ttl;
}
exports.isExpired = isExpired;
//# sourceMappingURL=is-expired.js.map